export class ProductFilterOptionModel {
  constructor(value, label) {
    this.value = value;
    this.label = label;
  }

  static formatSeasonLabel(seasonId) {
    if (!seasonId) {
      return '';
    }
    seasonId = seasonId.toString();
    const seasonType = seasonId.charAt(seasonId.length - 1);
    const seasonYear = parseInt(seasonId.substr(0, seasonId.length - 1), 10);
    return seasonType == 1 ? `FW ${seasonYear - 1}/${seasonYear}` : `SS ${seasonYear}`;
  }
}

export class ProductFilterSelectModel {
  constructor(name, options) {
    this.name = name;
    this.options = options;
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product-filter/product-filter.model.js